import React from 'react';
import PageHeader from './PageHeader';

const MovingForward = ({ assessment }) => {
	const name = assessment?.name || 'INSERT NAME';
	console.log({assessment})
	const weakest = assessment?.sortedScore?.[2]?.[0];
	return (
		<div className="Overview">
			<PageHeader title="Moving Forward" />
			<div className="max-w-5xl mx-auto px-12 py-4">
				<h2 className="text-25 font-bold mt-8 mb-6">
					Moving Forward
				</h2>
				<p className="mb-4 leading-normal text-[10pt]">
					<span className="font-bold">{name}</span>, to become an ideal team player, the best thing you can do is focus on strengthening your weakest area—<span className="font-bold">{weakest}</span>. While all three virtues—humble, hungry, and smart—are important, the greatest impact comes from improving the one that needs the most attention. Small, intentional changes in this area will make a big difference in how you contribute to your team.
				</p>

				{/* Two bullet items */}
				<ul className="mb-4 space-y-6 ">
					<li className="flex items-start">
						<span className="bullet-itp"></span>
						<div className="ml-3">
							<p className="font-bold text-[12pt] mb-1">Start with Vulnerability</p>
							<p className="leading-normal text-[10pt]">
								Real growth begins when you share your assessment results with others. Talk with your manager, a trusted colleague, or a mentor. Let them know what you’re working on and ask for their honest feedback. Their insights and encouragement will help you stay accountable and accelerate your progress.
							</p>
						</div>
					</li>
					<li className="flex items-start">
						<span className="bullet-itp"></span>
						<div className="ml-3">
							<p className="font-bold text-[12pt] mb-1">Embrace the Challenge</p>
							<p className="leading-normal text-[10pt]">
								As you work on this, pay attention to moments when you feel uncomfortable or defensive—this is often a sign that you have an opportunity to learn and grow.
								Improvement takes time, so be patient with yourself and give yourself a little grace. Stay committed, lean into feedback, and trust the process.
							</p>
						</div>
					</li>
				</ul>

				<h3 className="text-20 font-bold mb-1 mt-16">Next Steps</h3>

				<section className="mx-auto pt-6 max-w-4xl moving-forward-section">
					<div className="w-[85%] mx-auto flex justify-between">
						<img
							src="/images/itp/itp-next-steps.png"
							alt="Next steps process"
							className="w-full"
						/>
					</div>

					<div className="flex justify-between pt-4">
						<div className="w-1/3 px-4">
							<hr />
							<p className="text-[9pt] leading-normal text-left">
								You’ve taken the first step by completing the Ideal Team Player Assessment.
								This has provided insight into how you currently embody the virtues of
								humility, hunger, and people smarts, and sets the foundation for your
								personal development journey.
							</p>
						</div>

						<div className="w-1/3 px-4">
							<hr />
							<p className="text-[9pt] leading-normal text-left">
								Over the next several weeks, you’ll receive a series of three coaching emails
								with practical strategies tailored to improving{' '}
								<span className="font-bold">{weakest}</span>. Each message will challenge
								you to apply new behaviors, reflect on your progress, and make appropriate
								adjustments along the way.
							</p>
						</div>

						<div className="w-1/3 px-4">
							<hr />
							<p className="text-[9pt] leading-normal text-left">
								At the end of this journey, you’ll have the chance to reassess yourself
								and track your progress. After the final coaching email, you’ll receive a
								link to retake the assessment. Your personalized Progress Report will
								highlight your development and identify opportunities for continued growth.
							</p>
						</div>
					</div>
				</section>
			</div>
		</div>
	);
};

export default MovingForward;
